import * as React from "react";
import * as PropTypes from "../prop-types";

const propsDoc = {
    maxHeight: "string",
};

const propTypes = {
    ...PropTypes.spsGlobalPropTypes,
    maxHeight: PropTypes.string,
};

export type SpsScrollableContainerProps = PropTypes.InferTS<typeof propTypes, HTMLDivElement>;

export function SpsScrollableContainer(props: SpsScrollableContainerProps) {
    const {
        children,
        maxHeight,
    } = props;
    return (
        <div className="sps-scrollable-container" style={{maxHeight: maxHeight}}>
            {children}
        </div>
    );
}

Object.assign(SpsScrollableContainer, {
    props: propsDoc,
    propTypes,
    displayName: "SpsScrollableContainer"
});
